import { useEffect, useState } from 'react';

import { formatElapsed } from '@/lib/limulo/code';

/**
 * A live countdown string to `deadlineAt` (an ISO timestamp), re-rendered every
 * second: `m:ss` under an hour, `h:mm:ss` from an hour up. Returns `null` when
 * there is no deadline or it has already passed — so a caller can branch on
 * "still ticking" vs "expired".
 *
 * 🔴 Il formato NON e' definito qui: e' `formatElapsed` (`lib/limulo/code.ts`), lo stesso di «In coda da…»
 * nella stessa barra, cosi' i due conti non divergono il giorno che uno cambia (i giorni, per esempio).
 * Minuti SENZA zero davanti sotto l'ora («59:59», «9:05», «0:07»); dall'ora in su ore senza zero davanti,
 * minuti e secondi a due cifre («1:00:00», «23:59:59», «47:10:03»); niente giorni. Il bordo e' a 3600
 * secondi, compreso: 3599 → «59:59», 3600 → «1:00:00». Sotto il secondo si arrotonda PER DIFETTO: un
 * millisecondo prima dell'ora dice «59:59», 999 ms alla scadenza dicono «0:00».
 * Fino a qui il conto aveva SOLO minuti e secondi: una scadenza lontana ore (la sfida di piattaforma nella
 * barra, `expiresAt`, a 24 ore; un check-in d'incontro fino a 120 minuti) usciva «1439:59», «75:00».
 *
 * Shared by the match check-in surfaces (tournament detail + queue sheet) and the
 * persistent action bar (`AzionePersistente`, where a platform challenge can be
 * hours away): all put a live countdown next to the action while the window runs.
 */
export function useCountdown(deadlineAt: string | null | undefined): string | null {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!deadlineAt) return;
    const id = window.setInterval(() => tick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [deadlineAt]);

  if (!deadlineAt) return null;
  const ms = new Date(deadlineAt).getTime() - Date.now();
  if (!Number.isFinite(ms) || ms <= 0) return null;
  return formatElapsed(ms);
}
